/**
 * GET Booking Action
 */
import * as _ from 'lodash-es';
import { history } from '../../helpers/history';

import {
  ACTION_GET_BOOKING,
  ACTION_GET_BOOKING_SUCCESS,
  ACTION_GET_BOOKING_FAILURE,
  ACTION_EMPTY_BOOKING,
  API_CALL,
} from '../../configs/ActionTypes';

import { Dispatch } from 'redux';

import { enqueueSnackbarHandler } from '../Status';

/**
 * POST Users Request Action
 */
export function getSingle(bookingId: string, navigate: Function) {
  return (dispatch: Dispatch, getState: Function) => {
    dispatch(requestStarted());

    dispatch({
      type: API_CALL,
      payload: {
        call: `bookings/${bookingId}`,
        method: 'get',
        success: (response: any) => {
          if (response.type === 'error') {
            if (response.payload.bookingsNotFound === true) {
              navigate(`/lookup`);
              return;
            }

            enqueueSnackbarHandler(dispatch, response.payload.payload, 'error');
            dispatch(requestFailed(response));
          } else {
            dispatch(requestSuccess(response));
          }
        },
        fail: (error: any) => {
          if (error.payload.bookingsNotFound === true) {
            navigate(`/lookup`);
            return;
          }

          enqueueSnackbarHandler(dispatch, error.payload, 'error');
          dispatch(requestFailed(error));
        },
      },
    });

    return null;
  };
}

export function requestStarted() {
  return {
    type: ACTION_GET_BOOKING,
    payload: null,
  };
}

export function requestSuccess(responseJSON: object) {
  return {
    type: ACTION_GET_BOOKING_SUCCESS,
    payload: responseJSON,
  };
}

export function requestFailed(responseJSON: object) {
  return {
    type: ACTION_GET_BOOKING_FAILURE,
    payload: responseJSON,
  };
}

export function emptyBooking() {
  return (dispatch: Dispatch) => {
    dispatch({
      type: ACTION_EMPTY_BOOKING,
      payload: null,
    });
  };
}
